export default "__VITE_ASSET__7ef0293b__"